module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedRegular.woff";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedRegular.woff
// module id = 1004
// module chunks = 19